export const APP_NAME = 'unsubscribe-ui';
export const SCREENS = {
  CONFIRMATION: 'confirmation-page',
  UNSUBSCRIBE_ALL_PAGE: 'unsubscribe-all-page',
  UNSUBSCRIBE_SINGLE_PAGE: 'unsubscribe-single-page'
};
export const MODULES = {
  UNSUBSCRIBE_SURVEY: 'unsubscribe-survey'
};
export const ACTIONS = {
  SURVEY_SUBMIT: 'survey-submit',
  BACK_TO_MANAGE_PREFERENCES: 'back-to-manage-preferences',
  UNSUBSCRIBE_ALL: 'unsubscribe-all',
  UNSUBSCRIBE_SINGLE: 'unsubscribe-single'
};